'use client';

import { useAppContext } from '@lib/context/appContext';
import { getPathFromMarket } from '@lib/utils/clUtils';
import { isB2BEnabled } from '@utils/config';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { B2BHome } from './B2BHome';

export const Home = ({ locale }: { locale: string }) => {
  const router = useRouter();
  const { state } = useAppContext();
  const hasRedirected = useRef(false);
  const searchParams = useSearchParams();

  const redirect = async () => {
    const { marketId } = state;
    const redirectUrl = getPathFromMarket(marketId, locale);
    const search = searchParams.toString();
    const url = `${redirectUrl}${search ? `?${search}` : ''}`;

    router.push(url);
  };

  useEffect(() => {
    if (isB2BEnabled || !state?.marketId || hasRedirected.current) {
      return;
    }
    hasRedirected.current = true;
    redirect();
  }, [state, hasRedirected, router, searchParams]);

  if (isB2BEnabled) {
    return <B2BHome />;
  }
};
